import * as React from "react";

function BloombergSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={102.304}
      height={20.647}
      {...props}
    >
      <defs>
        <style>{".prefix__a{fill:#e6e6e6}"}</style>
      </defs>
      <path
        className="prefix__a"
        d="M2.706 2.666h2.213c2.03 0 2.923.643 2.923 1.942 0 1.137-.893 1.908-2.706 1.908h-2.43zM0 15.522h5.447c2.869 0 5.731-1.022 5.731-4.317A3.6 3.6 0 007.91 7.551v-.108a3.383 3.383 0 002.632-3.309C10.542 1.408 8.187.359 5.9.359H0zm2.706-6.726h2.572c2.179 0 3.207.555 3.207 2.138 0 1.982-1.922 2.219-3.315 2.219H2.706z"
      />
      <path
        fill="none"
        stroke="#e6e6e6"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="M14.222 15.488V0"
      />
      <path
        className="prefix__a"
        d="M19.784 10.359a3.011 3.011 0 113.011 3.011 3.011 3.011 0 01-3.011-3.011m-2.564 0a5.337 5.337 0 005.575 5.413 5.327 5.327 0 005.582-5.413 5.327 5.327 0 00-5.582-5.413 5.322 5.322 0 00-5.575 5.413M32.098 10.359a3.018 3.018 0 116.029 0 3.018 3.018 0 11-6.029 0m-2.564 0a5.339 5.339 0 005.582 5.413 5.323 5.323 0 005.582-5.413 5.327 5.327 0 00-5.582-5.413 5.327 5.327 0 00-5.582 5.413M42.261 5.226h2.44v1.6h.041a3.255 3.255 0 013.139-1.861 3.1 3.1 0 013.207 1.9 3.586 3.586 0 013.383-1.9c2.706 0 3.7 1.949 3.7 4.4v6.09h-2.57v-5.78c0-1.279-.386-2.4-1.908-2.4s-2.2 1.353-2.2 2.652v5.555h-2.567v-6.09c0-1.265-.514-2.1-1.752-2.1-1.685 0-2.348 1.238-2.348 2.612v5.6h-2.565zM68.743 10.359a3.018 3.018 0 11-6.029 0 3.018 3.018 0 116.029 0m-8.525 5.129h2.436v-1.536h.041a3.965 3.965 0 003.532 1.793c3.16 0 5.068-2.355 5.068-5.413s-2.03-5.413-4.96-5.413a4.2 4.2 0 00-3.485 1.563h-.068V0h-2.564zM75.036 9.337a2.558 2.558 0 012.652-2.443A2.368 2.368 0 0180.3 9.337zm7.828 1.922v-.677C82.864 7.009 80.915 5 78.053 5a5.323 5.323 0 00-5.581 5.41 5.605 5.605 0 009.919 3.383l-1.84-1.353a3.383 3.383 0 01-2.754 1.353 2.659 2.659 0 01-2.761-2.436zM84.536 5.231h2.563v1.624h.041a3.254 3.254 0 013.031-1.881 3.193 3.193 0 01.92.149v2.483a5.068 5.068 0 00-1.238-.162 2.585 2.585 0 00-2.761 2.591v5.489h-2.563V5.231zM96.83 7.281a2.855 2.855 0 013.038 3.018 2.882 2.882 0 01-3.058 3.011 2.964 2.964 0 01-3.011-2.97 2.9 2.9 0 013.031-3.058m3.038-2.03v1.514h-.041a3.965 3.965 0 00-3.53-1.793c-3.16 0-5.061 2.348-5.061 5.413a5.02 5.02 0 005.108 5.257 4.175 4.175 0 003.383-1.5h.041v.738c0 2.03-.765 3.444-3.248 3.444a4.966 4.966 0 01-3.532-1.482l-1.563 2.1a7.3 7.3 0 005.088 1.692c4 0 5.792-2.355 5.792-6.049v-9.36z"
      />
    </svg>
  );
}

export default BloombergSvg;
